import React from 'react';
import { Phone, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

export const Hero = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hola, necesito solicitar un servicio técnico.');
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=${message}`, '_blank');
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1717176876437-490aa75bf9b5" 
          alt="Técnico profesional"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-800/90 to-blue-900/85"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <div className="inline-block mb-6">
            <span className="bg-white/20 backdrop-blur-sm text-white px-6 py-2 rounded-full text-sm font-medium border border-white/30">
              Servicio Profesional Garantizado
            </span>
          </div>
          
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Reparación Experta de
            <span className="block text-blue-300">Electrodomésticos</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed">
            Técnicos certificados, servicio rápido y garantizado. 
            Solucionamos cualquier problema con tus electrodomésticos.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button 
              size="lg"
              onClick={handleWhatsAppClick}
              className="bg-white text-blue-900 hover:bg-blue-50 text-lg px-8 py-6 shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              <Phone className="w-5 h-5 mr-2" />
              Solicitar Servicio
            </Button>
            <Button 
              size="lg"
              variant="outline"
              onClick={() => {
                const element = document.getElementById('servicios');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-transparent border-2 border-white text-white hover:bg-white/10 text-lg px-8 py-6"
            >
              Ver Servicios
            </Button>
          </div>

          {/* Features list */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              'Técnicos Certificados',
              'Servicio a Domicilio',
              'Garantía Incluida'
            ].map((feature) => (
              <div 
                key={feature}
                className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg border border-white/20"
              >
                <CheckCircle className="w-5 h-5 text-blue-300 flex-shrink-0" />
                <span className="text-white font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};
